import { render } from "./emergencyEatXfbm.vue?vue&type=template&id=52eb6dcf"
import script from "./emergencyEatXfbm.vue?vue&type=script&lang=js"
export * from "./emergencyEatXfbm.vue?vue&type=script&lang=js"

import "./emergencyEatXfbm.vue?vue&type=style&index=0&id=52eb6dcf&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__